<template>
  <div
    :class="[
      variant ? `language-dropdown-container--${variant}` : '',
      className,
    ]"
    class="language-dropdown-container"
  >
    <p>{{ resource["AIAnalyzeChangeLanguageText"] }}</p>
    <b-dropdown
      class="language-dropdown"
      :text="
        languageItems
          .find((item) => item.key === language)
          ?.shortTitle?.toUpperCase()
      "
    >
      <b-dropdown-item
        @click="changeLanguage(item)"
        v-for="item in languageItems"
        :key="item.id"
        >{{ item.title }}</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>
<script>
import { languageItems } from '@/static/languageItems';
import ResourceManager from '@/services/resource.service';

export default {
  name: 'LanguageDropdown',
  props: {
    variant: {
      type: String,
      default: 'gray',
    },
    useCurrentLanguage: {
      type: Boolean,
      default: false,
    },
    selectedLanguage: {
      type: Number,
      default: null,
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      languageItems,
      language: null,
    };
  },
  created() {
    let currentLanguage = null;
    if (this.selectedLanguage) {
      currentLanguage = this.languageItems.find(
        (item) => item.id === this.selectedLanguage,
      );
      this.language = currentLanguage.key;
      return;
    }

    if (typeof ResourceManager.CurrentLang !== 'string') {
      currentLanguage = ResourceManager.CurrentLang.key;
    } else {
      currentLanguage = this.languageItems.find(
        (item) => item.code === ResourceManager.CurrentLang,
      );
    }
    this.language = currentLanguage.key;
  },
  methods: {
    changeLanguage(item) {
      this.language = item.key;
      this.$emit('setLanguage', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.language-dropdown-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &--gray {
    width: 100%;
    padding: 12px 16px;
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    background: #fafafa;

    ::v-deep .dropdown-toggle {
      &::after {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.52844 5.99969L4.46844 9.05969C4.20844 9.31969 4.20844 9.73969 4.46844 9.99969C4.72844 10.2597 5.14844 10.2597 5.40844 9.99969L8.00177 7.41302L10.5884 9.99969C10.8484 10.2597 11.2684 10.2597 11.5284 9.99969C11.7884 9.73969 11.7884 9.31969 11.5284 9.05969L8.46844 5.99969C8.2151 5.73969 7.78844 5.73969 7.52844 5.99969Z" fill="%23FF8D06"/></svg>');
      }
    }

    ::v-deep .language-dropdown {
      &.show {
        .dropdown-toggle {
          &::after {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5818 5.99969L7.9951 8.58635L5.40844 5.99969C5.14844 5.73969 4.72844 5.73969 4.46844 5.99969C4.20844 6.25969 4.20844 6.67969 4.46844 6.93969L7.52844 9.99969C7.78844 10.2597 8.20844 10.2597 8.46844 9.99969L11.5284 6.93969C11.7884 6.67969 11.7884 6.25969 11.5284 5.99969C11.2684 5.74635 10.8418 5.73969 10.5818 5.99969Z" fill="%23FF8D06"/></svg>');
          }
        }
      }
    }
  }

  &--yellow {
    width: calc(100% - 32px);
    margin: 8px auto 0;
    padding: 8px 8px 8px 16px;
    border-radius: 8px;
    background: #fff8ec;

    ::v-deep .dropdown-toggle {
      height: 20px;
      &::after {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5818 5.99969L7.9951 8.58635L5.40844 5.99969C5.14844 5.73969 4.72844 5.73969 4.46844 5.99969C4.20844 6.25969 4.20844 6.67969 4.46844 6.93969L7.52844 9.99969C7.78844 10.2597 8.20844 10.2597 8.46844 9.99969L11.5284 6.93969C11.7884 6.67969 11.7884 6.25969 11.5284 5.99969C11.2684 5.74635 10.8418 5.73969 10.5818 5.99969Z" fill="%23FF8D06"/></svg>');
      }
    }

    ::v-deep .language-dropdown {
      &.show {
        .dropdown-toggle {
          &::after {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.52844 5.99969L4.46844 9.05969C4.20844 9.31969 4.20844 9.73969 4.46844 9.99969C4.72844 10.2597 5.14844 10.2597 5.40844 9.99969L8.00177 7.41302L10.5884 9.99969C10.8484 10.2597 11.2684 10.2597 11.5284 9.99969C11.7884 9.73969 11.7884 9.31969 11.5284 9.05969L8.46844 5.99969C8.2151 5.73969 7.78844 5.73969 7.52844 5.99969Z" fill="%23FF8D06"/></svg>');
          }
        }
      }
    }
  }

  p {
    color: #333 !important;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
    text-align: start !important;
    margin: 0 !important;
  }

  ::v-deep {
    .language-dropdown {
      .dropdown-toggle {
        background: transparent !important;
        color: #ff8d06;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        transition: all 0.3s;
        padding: 0;

        &::after {
          margin-top: 4px;
          margin-left: 4px;
          border: 0 !important;
          transition: all 0.3s;
        }
      }
      .dropdown-menu {
        background-color: #ffffff !important;
        width: 100% !important;
        min-width: 100px !important;
        border-radius: 4px;
        border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
        box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
        z-index: 9999 !important;
        padding: 4px 0;
        left: 0 !important;
      }
      .dropdown-item {
        color: #333333 !important;
        text-transform: capitalize;
        padding: 6px 16px !important;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        &:first-child {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
        &:last-child {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
        &:hover {
          background-color: #eeeeee !important;
          color: #333333 !important;
        }
      }
    }
  }
}
</style>
